/**
 * account-screen.ts — Màn nào của Cài đặt cá nhân (`/account/:section?`) cần hiện. Hàm thuần, có test.
 *
 *   máy tính : có `section` hợp lệ → 'detail' (cột menu bên trái + nội dung); thiếu / sai → chuyển về mục đầu.
 *   điện thoại: không có `section` → 'list' (danh sách mục, kiểu Cài đặt của iPhone); có `section` hợp lệ → 'detail'
 *               (nội dung trọn màn hình + nút quay lại); `section` sai → quay về danh sách.
 */
export type AccountScreen = { kind: 'list' } | { kind: 'detail'; section: string } | { kind: 'redirect'; to: string }

export function accountScreen(section: string | undefined, ids: readonly string[], mobile: boolean): AccountScreen {
  const valid = section !== undefined && ids.includes(section)
  if (valid) return { kind: 'detail', section: section! }
  if (mobile) return section === undefined ? { kind: 'list' } : { kind: 'redirect', to: '/account' }
  return { kind: 'redirect', to: `/account/${ids[0]}` }
}
